<div class="container-fluid pb-3 pt-2">
  <h4 class="mb-2">{{headingText}}</h4>
  <div *ngIf="!loading; else loader">
    <mat-accordion>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Ricerca
          </mat-panel-title>
          <mat-panel-description>
            Ricerca avanzata polizze
          </mat-panel-description>
        </mat-expansion-panel-header>
        <ricerca-polizze [(search)]="search"></ricerca-polizze>
      </mat-expansion-panel>
    </mat-accordion>

    <resourceful-index 
      #index 
      [search]="search" 
      [modelService]="polizzaService" 
      [deleteFunction]="deleteFunction"
      [columnDefinitions]="columnDefinitions" 
      [editFunction]="editFunction" 
      [selectionMode]="selectionMode"
      [showAddButton]="true"
      [addButtonText]="'Aggiungi Polizza'"
      [addButtonIcon]="'add'"
      [showReset]="true"
      (selectedModel)="closeDialogWithSelectedModel($event)"
      (addClicked)="add()"
      [relations]="relations">
    </resourceful-index>
  </div>
  <ng-template #loader>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>